// The Slovenian texts are the prototype's own, word for word where a screen matches.
export default {
    offer: {
        save_hint: 'Odpre se tiskalno okno — za PDF izberite cilj »Shrani kot PDF«.',
        invalid_title: 'Ponudba ni na voljo',
        invalid_text: 'Povezava do ponudbe je potekla ali bila zamenjana. Obrnite se na hotel.',
        eyebrow: 'Ponudba za skupino',
        eyebrow_reservation: 'Ponudba za vas',
        nights: 'nočitev',
        financials: 'Ponudba',
        col_item: 'Postavka',
        col_quantity: 'Količina',
        col_price: 'Cena/enoto',
        col_discount: 'Popust',
        col_vat: 'DDV',
        col_amount: 'Znesek',
        total_net: 'Skupaj brez DDV',
        vat_at: 'DDV {rate} %',
        remaining: 'Za plačilo',
        rooms: 'Nastanitev',
        per_night: 'noč',
        up_to: 'do {count} oseb v sobi',
        total: 'Skupaj',
        paid: 'Že plačano',
        services: 'Storitve hotela',
        included: 'na voljo gostom',
        valid_until: 'Ponudba velja do {date}.',
        contact: 'Vprašanja in potrditev',
        print: 'Natisni',
        save: 'Shrani PDF',
        confirm: 'Potrdi ponudbo',
        confirmed_at: 'Ponudba potrjena {date}. Hvala — hotel je obveščen.',
        units: { hour: 'uro', day: 'dan', night: 'noč', person: 'osebo', use: 'uporabo', item: 'kos', treatment: 'tretma' },
    },
    rooming: {
        pick: 'Izberi …',
        invalid_title: 'Povezava ni veljavna',
        invalid_text: 'Povezava za vnos gostov je potekla ali bila zamenjana. Obrnite se na hotel.',
        intro: 'Vpišite goste svoje skupine. Hotel bo seznam pregledal in razporedil po sobah — vpis tu še ne pomeni rezervacije.',
        add_title: 'Dodaj gosta',
        first_name: 'Ime',
        last_name: 'Priimek',
        email: 'E-naslov',
        phone: 'Telefon',
        notes: 'Opombe',
        add: 'Dodaj',
        added: 'Gost je dodan na seznam.',
        failed: 'Vnosa ni bilo mogoče shraniti.',
        entered: 'Vpisani gostje ({count})',
        none_yet: 'Še ni vpisanih gostov.',
        booking_title: 'Vnos sopotnikov',
        rooms_title: 'Sobe',
        rooms_count: '{count} sob',
        filled_of: 'Vpisanih {filled} od {capacity}',
        pick_room_first: 'Najprej izberite sobo zgoraj.',
        adding_to: 'Dodajate v: {room}',
        unassigned: 'Nerazporejen',
        date_of_birth: 'Datum rojstva',
        nationality: 'Državljanstvo',
        nationality_hint: 'npr. SI',
        document_type: 'Vrsta dokumenta',
        document_type_hint: 'npr. potni list',
        document_number: 'Številka dokumenta',
        confirmed: 'Potrjeno',
        booked_note: 'Že razporejeni gostje so potrjeni s strani hotela; spremembe sporočite recepciji.',
        register_hint: 'Datum rojstva, državljanstvo in dokument potrebujemo za prijavo gosta po zakonu. Podatke na recepciji preverimo ob prihodu.',
    },
    keys: {
        title: 'Ključi',
        your_room: 'VAŠA SOBA',
        your_pin: 'VAŠA KODA PIN',
        pin_text: 'S kodo PIN odprete vsa svoja vrata, lahko pa uporabite daljinsko odpiranje spodaj.',
        your_keys: 'VAŠI KLJUČI',
        door_room: 'Soba',
        room_on_arrival: 'dodeljena ob prihodu',
        hold: 'Pridržite za odklep',
        unlocked: 'Odklenjeno',
        preview_note: 'Daljinsko odpiranje bo delovalo, ko hotel poveže ključavnice s sistemom — do takrat je predogled.',
        demo_done: 'Predogled — ključavnice še niso povezane.',
    },
    nav: {
        menu: 'Meni',
        roomservice_hint: 'Jedi in pijača naravnost v sobo',
        roomservice: 'Strežba v sobo',
        keys: 'Ključi',
        short_keys: 'Ključi',
        overview: 'Pregled',
        checkin: 'Prijava',
        stay: 'Moje bivanje',
        arrival: 'Prihod',
        services: 'Storitve',
        payments: 'Plačila in računi',
        short_overview: 'Pregled',
        short_checkin: 'Prijava',
        short_arrival: 'Prihod',
        short_services: 'Storitve',
        short_payments: 'Račun',
        house: 'Hotel',
    },
    general: {
        back: 'Nazaj',
        cancel: 'Prekliči',
        close: 'Zapri',
        save_failed: 'Shranjevanje ni uspelo. Poskusite znova.',
    },
    theme: {
        title: 'Svetla/temna tema',
        to_dark: 'Vklopi temno temo',
        to_light: 'Vklopi svetlo temo',
    },
    overview: {
        eyebrow: 'VAŠE NASLEDNJE BIVANJE',
        language: 'Jezik',
        welcome: 'Dobrodošli v',
        welcome_named: 'Pozdravljeni, {names}',
        and: 'in',
        subtitle: 'Tu uredite vse pred prihodom in med bivanjem.',
        arrival: 'PRIHOD',
        departure: 'ODHOD',
        reservation: 'REZERVACIJA',
        ready: 'Pripravljeni na prihod',
        almost: 'Skoraj pripravljeni',
        all_done: 'Vse je urejeno',
        one_more_step: 'Še en korak',
        steps_left_two: 'Še 2 koraka',
        steps_left_few: 'Še {n} koraki',
        step_profile: 'Osebni podatki',
        step_document: 'Dokument',
        step_payment: 'Plačilo',
        finish_checkin: 'Dokončaj prijavo',
        card_checkin: 'Spletna prijava',
        card_checkin_text: 'Dopolnite podatke gostov in skrajšajte postopek na recepciji.',
        card_checkin_go: 'Nadaljuj prijavo',
        card_stay: 'Moje bivanje',
        card_stay_text: 'Soba, čas prihoda, posebne želje in navodila za prihod.',
        card_stay_go: 'Poglej rezervacijo',
        card_services: 'Storitve hotela',
        card_services_text: 'Masaža, savna, večerja ali izposoja koles.',
        card_services_go: 'Razišči storitve',
        card_room_service: 'Strežba v sobo',
        card_room_service_text: 'Jedi in pijača iz hotelske kuhinje, naravnost v sobo.',
        card_room_service_go: 'Na jedilnik',
        card_money: 'Stroški in plačila',
        card_money_go: 'Odpri račun bivanja in plačilo',
        card_keys_title: 'Ključi',
        card_keys_none: 'Ključ in koda PIN vas čakata po prijavi in dodelitvi sobe.',
        card_keys_get: 'Pridobi ključ',
        card_keys_go: 'Vsi ključi in PIN',
        card_arrival: 'Prihod in lokacija',
        card_arrival_text: 'Naslov, navigacija ter fotografije vhoda, parkirišča in garaže.',
        card_arrival_go: 'Poglej navodila za prihod',
        card_house: 'Hotel in okolica',
        card_house_text: 'Wi-Fi, urniki, pismo dobrodošlice, cenik in kaj se dogaja v mestu.',
        card_house_go: 'Odpri informacije hotela',
        partly_paid: 'Delno plačano',
        charges: 'Stroški bivanja',
        parking_charges: 'Stroški parkiranja',
        paid: 'Plačano',
        balance: 'Preostanek',
    },
    checkin: {
        pick: 'Izberi …',
        title: 'Spletna prijava',
        subtitle: 'Podatki se varno prenesejo neposredno v hotel.',
        step_guests: 'Gostje',
        step_documents: 'Dokumenti',
        step_payment: 'Plačilo',
        step_confirm: 'Potrditev',
        guests_title: 'Gostje na rezervaciji',
        unnamed: 'Gost brez imena',
        document_read: 'Dokument prebran · podatki popolni',
        document_missing: 'Manjka dokument',
        document_entered: 'Podatki vneseni · recepcija jih preveri ob prihodu',
        done_badge: 'Končano',
        add_document: 'Vnesi podatke',
        add_companion: 'Dodaj spremljevalca',
        first_name: 'Ime',
        last_name: 'Priimek',
        companion_hint: 'Dodajte osebo, ki biva z vami. Dokument vnesete v naslednjem koraku, tako kot zase.',
        companion_room: 'Soba',
        companion_save: 'Dodaj osebo',
        companion_saved: 'Oseba je dodana — vnesite še njen dokument.',
        companion_incomplete: 'Vpišite ime in priimek (in izberite sobo).',
        companion_failed: 'Osebe ni bilo mogoče dodati — soba je morda že polna. Obrnite se na recepcijo.',
        wishes_title: 'Prihod in želje',
        expected_arrival: 'Predviden prihod',
        phone: 'Mobilna številka',
        phone_placeholder: '+386 41 234 567',
        wishes: 'Posebne želje',
        wishes_placeholder: 'Mirna soba, višje nadstropje',
        plate: 'Registrska številka',
        plate_hint: 'Če boste avto parkirali na parkirišču ali v garaži.',

        // Soglasje za marketing (docs/MARKETING.md §13). Nikoli vnaprej obkljukano.
        consent_title:  'Ponudbe po e-pošti',
        consent_label:  'Želim prejemati ponudbe in novice hotela po e-pošti.',
        consent_hint:   'Soglasje lahko kadar koli prekličeš — tudi z eno povezavo na dnu vsakega pisma. Sporočila o tvoji rezervaciji prihajajo ne glede na to.',
        consent_failed: 'Soglasja ni bilo mogoče shraniti.',
        save_for_later: 'Shrani za pozneje',
        continue_payment: 'Nadaljuj na plačilo',
        saved: 'Prijava je shranjena.',
        doc_title: 'Dodaj dokument',
        doc_type: 'Vrsta dokumenta',
        doc_number: 'Številka dokumenta',
        doc_nationality: 'Državljanstvo',
        doc_nationality_hint: 'Dvočrkovna koda države, npr. SI, DE, IT.',
        doc_birth: 'Datum rojstva',
        doc_save: 'Shrani podatke',
        doc_saved: 'Dokument je shranjen.',
        doc_incomplete: 'Izpolnite vsa polja — brez njih prijave gosta ni mogoče oddati.',
        doc_hint: 'Dokument preberite z aplikacijo Imprion ID Scan ali podatke vnesite ročno. Fotografija se ne shrani.',
        doc_manual: 'Ročni vnos',
        doc_idscan: 'Odpri ID Scan',
        doc_coming: 'Branje dokumenta prek portala prihaja kmalu — do takrat dokument preberejo na recepciji.',
    },
    stay: {
        requests_title: 'VAŠE PROŠNJE',
        request_extension: 'Podaljšanje za {nights} noči',
        request_late_checkout: 'Pozni odhod',
        request_pending: 'čaka na recepcijo',
        request_confirmed: 'potrjeno',
        request_declined: 'žal ne gre',
        title: 'Moje bivanje',
        room: 'Soba',
        room_assigned_on_arrival: 'Soba bo dodeljena ob prihodu',
        occupancy: '{adults} odraslih · {children} otrok',
        expected: 'pričakovano {hour}',
        late_checkout: 'Zaprosi za pozni odhod',
        // Odjava in sprostitev sobe sta dva dogodka (docs/HOUSEKEEPING.md §16).
        room_released_title: 'Odhod iz sobe',
        room_released_text: 'Odjavljeni ste, soba pa je pri nas še vedno zasedena. Ko sporočite, da ste jo zapustili, jo lahko gremo pripravit za naslednjega gosta.',
        room_released: 'Zapustil sem sobo',
        room_released_sent: 'Hvala - sporočili smo, da je soba prosta.',
        extension_check: 'Preveri možno podaljšanje',
        extension_title: 'Podaljšanje bivanja',
        extension_hint: 'Preverite, ali so noči po vašem odhodu še proste. Želja gre recepciji, ki podaljšanje potrdi — nič se ne rezervira samo.',
        extension_same_room: 'Prosto — lahko ostanete v isti sobi',
        extension_other_room: 'Prosto — z menjavo sobe',
        extension_full: 'Žal ni prostih sob za te noči.',
        extension_price: 'ocena {amount}/noč po vašem paketu',
        extension_request: 'Zaprosi za +{nights}',
        extension_sent: 'Želja za podaljšanje je poslana recepciji — odgovorili vam bodo.',
        late_checkout_sent: 'Prošnja za pozni odhod je poslana recepciji — odgovor boste videli tukaj.',
        call: 'Pokliči',
        status_booked: 'Rezervirano',
        status_confirmed: 'Potrjeno',
        status_checked_in: 'Prijavljeni',
        status_checked_out: 'Odjavljeni',
    },
    parking: {
        maps_card: 'Lokacija in navigacija v Google Maps',
        card_title: 'Parkiranje',
        card_title_both: 'Parkiranje in garaža',
        card_text: 'Vnesite registrsko številko za samodejno odpiranje zapornice ob prihodu in med bivanjem.',
        add: 'Dodaj registrsko številko',
        change: 'Spremeni ali dodaj dostop',
        active_badge: 'Zapornica aktivna',
        active_until: 'Samodejni vstop je aktiven do {date}.',
        title: 'Samodejni vstop v garažo',
        hint: 'Kamera pri zapornici bo med bivanjem prepoznala registrsko številko in samodejno odprla zapornico.',
        maps: 'Odpri v Google Maps',
        copy: 'Kopiraj naslov',
        copied: 'Naslov je kopiran.',
        plate: 'Registrska številka vozila',
        placeholder: 'npr. MB AB-123',
        validity: 'Veljavnost dostopa',
        validity_range: '{from} do {to}',
        activate: 'Potrdi in aktiviraj',
        activated: 'Registrska številka {plate} je aktivirana za samodejni vstop.',
        check_plate: 'Preverite registrsko številko.',
        extra_cars: 'Dodatna vozila',
        add_car: 'Dodaj dodaten avto',
        remove_car: 'Odstrani',
        removed: 'Registrska je odstranjena; zapornica je ne bo več spustila.',
        removed_booking_kept: 'Registrska je odstranjena. Rezervacije parkirišča prek portala ni več mogoče odpovedati — uredi jo recepcija.',
        first_car_price: 'Parkirno mesto za bivanje: {amount}. Znesek se doda na račun bivanja.',
        included_note: 'Parkiranje je vključeno v ceno nočitve.',
        remove_car_done: 'Rezervacija za {plate} je odpovedana in odšteta z računa bivanja.',
        add_car_price: 'Parkirno mesto za preostanek bivanja: {amount}. Znesek se doda na račun bivanja.',
        add_car_book: 'Rezerviraj in dodaj na račun',
        add_car_done: 'Parkirno mesto za {plate} je rezervirano in dodano na račun bivanja.',
    },
    arrival: {
        title: 'Prihod v hotel',
        navigate: 'Navigacija',
        back_to_stay: 'Nazaj na bivanje',
        entrance_title: 'Glavni vhod',
        entrance_text: 'Kratek postanek za prtljago in dostop brez stopnic.',
        parking_title: 'Zunanje parkirišče',
        parking_text: 'Vstop s svojo registrsko številko.',
        garage_title: 'Vhod v garažo',
        garage_text: 'Zapornica se odpre samodejno, ko kamera prepozna registrsko številko vozila.',
    },
    services: {
        room_service_link: 'Strežba v sobo',
        title: 'Storitve in doživetja',
        subtitle: 'Storitev lahko dodate neposredno na račun bivanja.',
        loading: 'Nalagam ponudbo …',
        booked_title: 'ŽE REZERVIRANO',
        edit: 'Uredi',
        edit_close: 'Zapri urejanje',
        edit_save: 'Potrdi spremembo',
        edit_hint: 'Izberi nove dni; strnjeno obdobje brez lukenj.',
        edit_gap: 'Izberi strnjene dni — za dve ločeni obdobji naredi dve rezervaciji.',
        edited: 'Rezervacija je prestavljena.',
        edit_failed: 'Spremembe ni bilo mogoče izvesti — dnevi so morda že zasedeni. Preveri seznam.',
        desk_only_now: 'Sprememba ali odpoved samo še prek recepcije.',
        withdraw: 'Odpovej',
        withdrawn: 'Rezervacija je odpovedana. Če je bila že zaračunana, je znesek storniran.',
        withdraw_failed: 'Odpovedi ni bilo mogoče izvesti — obrnite se na recepcijo.',
        policy_until_start: 'Brezplačna odpoved prek portala do začetka.',
        policy_hours: 'Brezplačna odpoved prek portala do {hours} h pred začetkom.',
        policy_desk_only: 'Odpoved samo prek recepcije.',
        quantity: 'Koliko',
        per_days: '/ {days} dni',
        days_count: '{days} dni',
        full_days: 'Zasedeno: {days}',
        plate_nth: 'Registrska {number}. vozila',
        per_day: '/ dan',
        stay_total: '{amount} za {nights} dni',
        book: 'Rezerviraj za bivanje',
        full: 'Za vaše bivanje ni več prostih mest.',
        none: 'Hotel trenutno ne ponuja storitev, ki bi jih lahko rezervirali prek portala. Za termine (masaža, večerja) se obrnite na recepcijo.',
        confirm_text: 'Rezervacija za celotno bivanje, {from}–{to}. Znesek {amount} se doda na vaš hotelski račun.',
        confirm: 'Potrdi rezervacijo',
        cancel: 'Prekliči',
        needs_plate: 'Vpišite registrsko številko vozila.',
        booked: 'Rezervirano. Storitev je na vašem računu bivanja.',
        book_failed: 'Rezervacija ni uspela — poskusite znova ali se obrnite na recepcijo.',
        status_booked: 'rezervirano',
        status_in_progress: 'v teku',
        status_completed: 'opravljeno',
        status_cancelled: 'preklicano',
        status_no_show: 'neizkoriščeno',
    },
    room_service: {
        categories: 'Jedilnik',
        my_orders: 'Vaša naročila',
        basket_open: 'Košarica',
        basket_title: 'Vaše naročilo',
        when: 'Čas dostave',
        when_asap: 'Čim prej',
        when_today: 'Danes ob {time}',
        when_tomorrow: 'Jutri ob {time}',
        closed_now_later: 'Kuhinja zdaj ne streže — naročilo lahko oddate za kasneje.',
        ordered_at: 'naročeno {when}',
        deliver_for: 'dostava {when}',
        ordered_for: 'Naročilo je sprejeto za {time} — {amount} na računu sobe.',
        title: 'Strežba v sobo',
        subtitle: 'Naročite iz hotelske kuhinje — znesek se zapiše na račun sobe.',
        loading: 'Nalagam jedilnik …',
        load_failed: 'Jedilnika ni bilo mogoče naložiti. Preverite povezavo in poskusite znova.',
        retry: 'Poskusi znova',
        to_room: 'DOSTAVA V SOBO {room}',
        hours: 'Kuhinja danes: {hours}',
        shut_today: 'danes zaprto',
        closed_now: 'Kuhinja trenutno ne sprejema naročil. Poskusite v času, ko je odprta.',
        less: 'Odstrani enega',
        more: 'Dodaj enega',
        empty_menu: 'Hotel na jedilnik še ni dodal ničesar.',
        basket: 'VAŠE NAROČILO',
        basket_empty: 'Z gumbom + dodate jed ali pijačo.',
        total: 'Skupaj',
        note: 'Sporočilo kuhinji',
        note_placeholder: 'npr. brez čebule, dva pribora',
        terms: 'Ob potrditvi kuhinja prejme naročilo, znesek pa se zapiše na račun sobe in plača ob odjavi.',
        order: 'Naroči · {amount}',
        sending: 'Oddajam …',
        clear: 'Izprazni',
        orders: 'VAŠA NAROČILA',
        ordered: 'Naročilo je sprejeto — {amount} na računu sobe.',
        retry_hint: 'Odgovora ni bilo. Pritisnite Naroči znova — naročilo ne bo podvojeno.',
        failed: 'Kuhinja naročila ni sprejela. Preverite naročilo in poskusite znova ali pokličite recepcijo.',
        not_offered: 'Hotel strežbe v sobo prek portala ne ponuja. Za naročilo pokličite recepcijo.',
        not_in_house: 'Strežba v sobo je na voljo, ko ste prijavljeni v hotelu.',
        menu_unreadable: 'Jedilnika trenutno ni mogoče prebrati. Poskusite čez nekaj minut ali pokličite recepcijo.',
    },
    stay_services: {
        per_appointment: '/ termin',
        opens_at_checkin: 'Termine v hotelu (masaža, savna …) in ponudbo partnerjev v bližini lahko rezervirate, ko ste prijavljeni v hotelu.',
        room: 'Za katero sobo',
        appointments: 'TERMINI V HOTELU',
        loading_times: 'Preverjam proste termine …',
        times_failed: 'Prostih terminov ni bilo mogoče prebrati. Poskusite znova.',
        departed: 'Vaše bivanje se je izteklo — novih terminov ni več mogoče rezervirati.',
        no_times: 'Do vašega odhoda ni prostih terminov.',
        departure_day: 'Na dan odhoda so na voljo le termini, ki se končajo do {time}.',
        book: 'Rezerviraj · {amount}',
        on_bill: 'na račun sobe',
        booked: 'Termin je rezerviran — {amount} na računu sobe.',
        book_failed: 'Termina ni bilo mogoče rezervirati — morda je medtem zaseden. Izberite znova.',
        nearby: 'STORITVE V BLIŽINI',
        minutes: '{minutes} min',
        partner_down: 'Partner se trenutno ne odziva. Poskusite čez nekaj minut ali vprašajte na recepciji.',
        no_times_day: 'Ta dan pri partnerju ni prostih terminov.',
        partner_terms: 'Termin rezerviramo pri partnerju {partner}. Plača se po dogovoru s hotelom — na račun sobe ali pri partnerju.',
        nearby_done: 'Termin je rezerviran — pričakujejo vas.',
        taken: 'Ta termin je pri partnerju medtem zaseden. Izberite drugega.',
        nearby_booked: 'VAŠI TERMINI PRI PARTNERJIH',
        cancel: 'Odpovej',
        cancel_confirm: 'Potrdi odpoved',
        cancel_changed: 'Strošek odpovedi se je medtem spremenil.',
        cancel_unknown: 'Za odpoved lahko veljajo pogoji partnerja {partner} — za strošek vprašajte na recepciji ali potrdite odpoved.',
        cancel_late: 'Pozna odpoved: partner zaračuna {amount} na vašo sobo.',
        cancel_late_free: 'Rok za brezplačno odpoved je potekel, a partner za to storitev ne zaračuna ničesar.',
        cancel_free: 'Odpoved je brezplačna do {deadline}.',
        cancel_gone: 'Tega termina ni več mogoče odpovedati tukaj. Vprašajte na recepciji.',
        cancelled: 'Termin je odpovedan.',
        cancelled_fee: 'Termin je odpovedan. Partner bo zaračunal {amount} na račun sobe.',
        cancel_failed: 'Odpovedi ni bilo mogoče izvesti. Poskusite znova ali vprašajte na recepciji.',
    },
    order_pin: {
        title: 'PIN za naročila',
        hint: 'Hotel pred naročilom ali rezervacijo vpraša za vaš PIN. Dobili ste ga ob prijavi na recepciji ali po e-pošti.',
        label: 'PIN',
        confirm: 'Potrdi',
        wrong: 'PIN ni pravi. Poskusite znova.',
        locked: 'Preveč napačnih poskusov. Poskusite čez nekaj minut ali vprašajte na recepciji.',
    },
    payment_done: {
        paid_title: 'Plačilo uspešno',
        paid_text: 'Hvala! Plačilo je bilo izvedeno — recepcija ga bo v nekaj sekundah videla knjiženega.',
        cancelled_title: 'Plačilo ni bilo izvedeno',
        cancelled_text: 'Nič ni bilo bremenjeno. Za nov poskus prosite recepcijo.',
    },
    payments: {
        details_open: 'Poglej naročilo',
        details_total: 'Skupaj',
        details_tax: 'od tega DDV {rate} %: {amount}',
        title: 'Plačila in računi',
        reservation: 'Rezervacija {number}',
        open_badge: 'Odprto',
        folio_title: 'Račun bivanja',
        due: 'Za plačilo',
        pay_starting: 'Odpiram plačilo …',
        pay_failed: 'Plačila ni bilo mogoče začeti — poskusite znova ali se obrnite na recepcijo.',
        paid_message: 'Plačilo je uspelo. Hvala!',
        method_cash: 'gotovina',
        method_card: 'kartica',
        method_transfer: 'nakazilo',
        method_voucher: 'vrednostni bon',
        method_prepayment: 'predplačilo',
        method_ota_virtual_card: 'virtualna kartica',
        processing_title: 'Plačilo se obdeluje',
        processing_text: 'Čakamo potrditev ponudnika plačil. To običajno traja nekaj sekund — stran bo sama sporočila, ko bo plačilo knjiženo.',
        processing_timeout: 'Potrditve še ni. Če je bilo plačilo izvedeno, se bo v kratkem pojavilo med postavkami — sicer se obrnite na recepcijo.',
        overpaid_message: 'Plačani znesek je višji od odprtega — razliko bo recepcija uskladila kot dobroimetje.',
        cancelled_message: 'Plačilo je bilo preklicano.',
        settled_badge: 'Poravnano',
        stripe_note: 'Kartico vpišete na varni Stripovi strani; hotel podatkov o kartici ne vidi in ne hrani. Testno okolje.',
        pay_now: 'Plačaj zdaj',
        proforma: 'Prenesi predračun',
        proforma_failed: 'Predračuna ni bilo mogoče pripraviti — poskusite znova.',
        invoices: 'Računi',
        invoices_text: 'Končni davčno potrjen račun bo na voljo po zaključku bivanja.',
        documents: 'Dokumenti',
        no_invoice_yet: 'Končni račun še ni izdan.',
        secure_title: 'Varno plačilo',
        secure_text: 'Podatkov kartice hotel in Imprion ne hranita.',
        pay_title: 'Plačilo {amount}',
        simulated: 'Simulirano plačilo — kartica ne bo bremenjena.',
        simulated_done: 'To je bila simulacija — spletno plačilo pride z eno od naslednjih različic.',
        cardholder: 'Imetnik kartice',
        card_number: 'Številka kartice',
        expiry_cvc: 'Velja / CVC',
        pay_secure: 'Varno plačaj',
    },
    studio: {
        button: 'Prilagodi portal',
        title: 'Prilagoditev hotelskega portala',
        hint: 'Predogled za nastavitev posameznega objekta. Imprion Guest ostane označen kot ponudnik portala.',
        primary: 'Glavna barva',
        accent: 'Poudarjena barva',
        compact: 'bolj oglati elementi',
        preview_only: 'Samo predogled — videz hotela shrani recepcija.',
    },
    license: {
        eyebrow: 'Spletna prijava',
        title: 'Ta storitev ni vključena',
        lead: 'Ta hotel spletne prijave ne omogoča, zato tega portala ni mogoče odpreti. Vaša rezervacija s tem ni v ničemer spremenjena.',
        another_link: 'Če ste medtem prejeli drugo povezavo, jo preprosto odprite — ta stran se bo naložila znova.',
        contact: 'Za vse o svojem bivanju se obrnite na recepcijo hotela — z veseljem vam pomagajo.',
    },
    // Spomin na bivanje: kar povezava odpre, ko je bivanje mimo (docs/POTEK_GOSTA.md §9b).
    //
    // Stran nima nobenega osebnega podatka — ne imena, ne ključa, ne zneska — in tudi
    // besedilo tu ga nikoli ne sme uvesti. Nagovor je zato brezoseben: „Hvala za obisk",
    // ne „Hvala, Ana".
    memory: {
        eyebrow: 'Spomin na bivanje',
        thanks: 'Hvala za obisk',
        lead: 'Veseli smo bili vašega obiska. Tukaj ostaja kratek spomin na vaše bivanje.',
        stayed: 'Bivanje',
        room: 'Soba',
        used: 'Kar ste koristili',
        nights: 'Nočitve',
        nights_one: '{n} noč',
        nights_two: '{n} noči',
        nights_few: '{n} noči',
        nights_many: '{n} noči',
        guests: 'Gostje',
        guests_one: '{n} oseba',
        guests_two: '{n} osebi',
        guests_few: '{n} osebe',
        guests_many: '{n} oseb',
        book_again: 'Rezervirajte znova',
        invoice: 'Prosim račun na e-pošto',
        invoice_sending: 'Pošiljam …',
        invoice_sent: 'Račun je poslan na e-naslov, ki ste ga navedli.',
        invoice_failed: 'Računa zdaj ni bilo mogoče poslati. Poskusite kasneje ali pišite hotelu.',
        privacy: 'Ta stran ostaja odprta in ne vsebuje osebnih podatkov.',
    },
    invalid: {
        demo_opening: 'Odpiram bivanje …',
        hotel_fallback: 'Vaš hotel',
        reception: 'Recepcija',
        eyebrow: 'Potrebujete novo povezavo?',
        title: 'Brez skrbi — hitro uredimo novo',
        text: 'Ta povezava zaradi varnosti ne velja več. Vaša rezervacija s tem ni preklicana in noben podatek ni bil izgubljen.',
        help_title: 'Kako nadaljevati',
        step_contact_title: 'Obrnite se na recepcijo',
        step_contact_text: 'Pokličite hotel ali mu pošljite kratko sporočilo.',
        step_identify_title: 'Povejte, za katero bivanje gre',
        step_identify_text: 'Zadostujeta ime gosta in predvideni datum prihoda.',
        step_open_title: 'Odprite novo povezavo',
        step_open_text: 'Hotel vam jo bo poslal po e-pošti ali sporočilu.',
        retry: 'Poskusi znova',
        security: 'Povezave časovno omejimo, da zaščitimo podatke o vašem bivanju.',
    },
    /*
     * Hiša — vsebina sobnih televizorjev na telefonu (docs/DISPLAY.md §9).
     *
     * Svoj imenski prostor, ker je to stavba in ne bivanje: isto besedilo vidi vsak gost
     * v hiši, ne glede na svojo rezervacijo. Izrazje je namenoma isto kot na zaslonih
     * (`house.*`, `local.kind_*` v pms-display), da hiša na steni in na telefonu ne
     * govori dveh jezikov.
     */
    house: {
        sign_up: 'Prijavi naju',
        signed_up: 'Prijavljeni',
        signup_count: '{count} prijavljenih',
        guest_deal: 'Za goste hotela: {deal}',
        voucher_title: 'Vaš kupon za popuste',
        voucher_open: 'Odpri kupon',
        voucher_note: 'Pokažite QR ali odprite povezavo pri partnerju — stran v živo potrdi, da ste gost hotela.',
        locked_eye: 'Se odklene ob prijavi',
        locked_text: 'Vsebine hotela — Wi-Fi, pismo dobrodošlice, program in okolica — se na vašem telefonu odklenejo ob prijavi. Se vidimo na recepciji!',
        title: 'Hotel',
        loading: 'Nalagam …',
        failed: 'Vsebine hotela trenutno ni mogoče prikazati. Poskusite čez nekaj trenutkov.',
        section_house: 'DOBRODOŠLI',
        section_letter: 'PISMO DOBRODOŠLICE',
        section_today: 'DANES V HOTELU',
        section_weather: 'VREME',
        section_services: 'STORITVE IN CENIK',
        section_events: 'DOGODKI V OKOLICI',
        section_places: 'ZNAMENITOSTI V OKOLICI',
        wifi: 'Brezžično omrežje',
        network: 'Omrežje',
        password: 'Geslo',
        wifi_open: 'Omrežje je odprto, gesla ne potrebujete.',
        hours: 'Urniki',
        phone_keys: 'Tipke telefona',
        room_phone: 'S telefona v sobi.',
        emergency: 'Klic v sili',
        per_day: '/ dan',
        per_item: '/ enkratno',
        to_services: 'Rezervirajte storitev',
        open_in_maps: 'Odpri v Google Zemljevidih',
        kind_sight: 'Znamenitost',
        kind_restaurant: 'Kje jesti',
        kind_activity: 'Aktivnost',
        kind_shop: 'Nakupi',
        kind_other: 'Drugo v okolici',
    },
    /* Napoved je Open-Meteo; `weather` je beseda za nebo, ki jo prevede zaslon. */
    weather: {
        today: 'danes',
        rain_chance: '{percent} %',
        clear: 'jasno',
        partly_cloudy: 'delno oblačno',
        overcast: 'oblačno',
        fog: 'megla',
        drizzle: 'rosenje',
        rain: 'dež',
        rain_showers: 'plohe',
        snow: 'sneg',
        snow_showers: 'snežne plohe',
        thunderstorm: 'nevihta',
    },
    /*
     * Milo, the house's assistant in the guest's own hands.
     *
     * Short sentences on purpose: this is read on a telephone, standing up, usually with
     * one hand. `executed` says "handed over" and never "done" — every one of the four
     * actions is a REQUEST the hotel then acts on, and a portal that said "done" would
     * be promising on the hotel's behalf.
     *
     * `result.*` is what a confirmed proposal DID, keyed by the outcome code the service
     * sends. The Slovenian 1/2/3-4/5+ forms are chosen in `libs/chatResult.ts` and not by
     * vue-i18n, for the reason written there; the other languages carry the same four
     * keys so that the two locale files never disagree about which keys exist.
     *
     * # `disclaimer` names no telephone number, and that is a finding rather than an
     * omission
     *
     * It was drafted as "… recepcija je dosegljiva na {phone}", and there is no {phone}
     * to put in it. This product models no reception telephone number:
     * `PropertyIdentity.Phone` is the contact of the company that ISSUES THE INVOICE and
     * sits beside the IBAN and the tax number; `DisplayHouse.ReceptionKey` is the digit
     * to press on the telephone beside the bed, which is no use to a guest reading this
     * in a car park; and the house's guest-info cards, where the number really lives,
     * are free prose a house types itself.
     *
     * Printing the invoicing contact under the word "recepcija" would be this portal
     * asserting a fact about the hotel that the hotel never told it — the one thing
     * Milo's own prompt forbids him in so many words. So the sentence points at
     * reception without dialling it, and Milo gives the actual number when he is asked,
     * out of `house_info`, which is where the house wrote it.
     *
     * The day a property grows a reception telephone of its own, this key gets its
     * {phone} back in all six files and the number joins the stay's `assistant` block.
     */
    milo: {
        title: 'Milo',
        greeting: 'Pozdravljeni, jaz sem Milo.',
        intro: 'Vprašajte me o hotelu in svojem bivanju — odgovorim v vašem jeziku.',
        placeholder: 'Napišite vprašanje …',
        send: 'Pošlji',
        thinking: 'Milo razmišlja …',
        still_working: 'Še iščem — lahko traja minuto.',
        disclaimer: 'Milo je pomočnik hotela. Ne sprejema plačil in ne izdaja računov; za vse ostalo je na voljo recepcija.',
        open: 'Odpri Mila',
        close: 'Zapri',
        chip_wifi: 'Wi-Fi',
        chip_wifi_text: 'Kakšno je geslo za Wi-Fi?',
        chip_breakfast: 'Zajtrk',
        chip_breakfast_text: 'Do kdaj je zajtrk?',
        chip_late_checkout: 'Pozni odhod',
        chip_late_checkout_text: 'Ali lahko v sobi ostanem dlje?',
        chip_today: 'Kaj se dogaja danes',
        chip_today_text: 'Kaj se danes dogaja v okolici?',
        confirm: 'Potrdi',
        decline: 'Ne, zdaj ne',
        executed: 'Oddano',
        declined: 'Ni oddano.',
        failed: 'Ni uspelo. Poskusite znova ali pokličite recepcijo.',
        expired: 'Ta predlog je potekel. Vprašajte znova.',
        already_decided: 'O tem predlogu je bilo že odločeno.',
        card_closed: 'Tega predloga ni več mogoče potrditi.',
        budget_spent: 'Za danes je vprašanj dovolj. Jutri spet, ali pokličite recepcijo.',
        throttled: 'Trenutek, prosim — poskusite znova čez nekaj sekund.',
        too_long: 'Milo je za to vprašanje potreboval predolgo. Vprašajte kaj bolj določnega, ali pokličite recepcijo.',
        interrupted: 'Milo je bil med odgovarjanjem prekinjen. Vprašajte prosim še enkrat.',
        unavailable: 'Milo trenutno ni na voljo. Recepcija vam pomaga.',
        result: {
            late_checkout_requested:    'Prošnja za pozni odhod je oddana recepciji.',
            guest_service_booked_one:   'Rezervirano za {count} dan.',
            guest_service_booked_two:   'Rezervirano za {count} dni.',
            guest_service_booked_few:   'Rezervirano za {count} dni.',
            guest_service_booked_other: 'Rezervirano za {count} dni.',
            room_request_raised:        'Prošnja je oddana gospodinjstvu.',
            reception_message_sent:     'Sporočilo je oddano recepciji.',
            room_service_ordered_one:   'Naročilo je v kuhinji: {count} postavka, {detail}.',
            room_service_ordered_two:   'Naročilo je v kuhinji: {count} postavki, {detail}.',
            room_service_ordered_few:   'Naročilo je v kuhinji: {count} postavke, {detail}.',
            room_service_ordered_other: 'Naročilo je v kuhinji: {count} postavk, {detail}.',
            lost_item_reported:         'Prijava je vpisana pod {detail}; recepcija vas obvesti.',
            transfer_requested:         'Prošnja za prevoz ({detail}) je pri recepciji.',
        },
    },
}
